import { apiClient } from './authService';

const notificationService = {
  list: async ({ unread = false } = {}) => {
    const params = {};
    if (unread) params.unread = 'true';
    const response = await apiClient.get('/notifications/', { params });
    return response.data;
  },

  unreadCount: async () => {
    const response = await apiClient.get('/notifications/unread_count/');
    return response.data;
  },

  markRead: async (id) => {
    const response = await apiClient.post(`/notifications/${id}/mark_read/`);
    return response.data;
  },

  markAllRead: async () => {
    const response = await apiClient.post('/notifications/mark_all_read/');
    return response.data;
  },
};

export default notificationService;
